module.exports = __webpack_public_path__ + "img/undraw_stripe_payments_o-7-aw.560d8329.svg";